@layer refine.base {
  :host {
    --_menu-panel-bg: var(--menu-panel-bg, var(--color-canvas));
    --_menu-panel-border-color: var(--menu-panel-border-color, var(--color-divider));
    --_menu-panel-blur: var(--menu-panel-blur, var(--blur-md));
    --_menu-panel-shadow: var(--menu-panel-shadow, var(--shadow-xl));

    position: relative;
    display: inline-block;
  }

  /* ========================================
       Menu Panel
       ======================================== */

  .menu-panel {
    position: fixed;
    inset-inline-start: 0;
    top: 0;
    z-index: calc(var(--z-popover) + 1);
    box-sizing: border-box;
    min-width: var(--menu-panel-min-width, 10rem);
    max-height: var(--menu-panel-max-height, min(70vh, 32rem));
    padding: var(--_panel-padding, var(--size-1));
    margin: 0;
    overflow-y: auto;
    pointer-events: none;
    background: var(--_menu-panel-bg);
    border: var(--border) solid var(--_menu-panel-border-color);
    border-radius: var(--menu-panel-radius, var(--rounded-lg));
    box-shadow: var(--_menu-panel-shadow);
    opacity: 0;
    backdrop-filter: blur(var(--_menu-panel-blur));
    transform: translateY(var(--overlay-enter-translate-y)) scale(var(--overlay-enter-scale));
    transform-origin: top left;
    transition:
      opacity 100ms var(--ease-spring),
      transform 100ms var(--ease-spring),
      display 100ms allow-discrete,
      overlay 100ms allow-discrete;
  }

  .menu-panel[data-placement='top-start'],
  .menu-panel[data-placement='top'],
  .menu-panel[data-placement='top-end'] {
    transform-origin: bottom left;
  }

  .menu-panel[data-placement='bottom-end'],
  .menu-panel[data-placement='right-start'],
  .menu-panel[data-placement='right'] {
    transform-origin: top right;
  }

  .menu-panel[data-open] {
    pointer-events: auto;
    opacity: 1;
    transform: translateY(0) scale(1);
    transition:
      opacity 150ms var(--ease-spring),
      transform 150ms var(--ease-spring),
      display 150ms allow-discrete,
      overlay 150ms allow-discrete;

    @starting-style {
      opacity: 0;
      transform: translateY(var(--overlay-enter-translate-y)) scale(var(--overlay-enter-scale));
    }
  }

  /* ========================================
       Menu Items (slotted ore-menu-item)
       ======================================== */

  ::slotted(ore-menu-item) {
    display: block;
  }

  ::slotted(ore-menu-separator) {
    display: block;
  }
}
